import React from "react";
import { Alert } from "antd";

/**
 * Minimal error boundary. Renders `fallback` (or a default Alert) when a child
 * subtree throws, instead of crashing the whole page. Useful for isolating an
 * optional/secondary widget so a failure in it doesn't take siblings down.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        this.props.fallback ?? (
          <Alert
            type="error"
            showIcon
            style={{ margin: 16 }}
            message={this.props.message || "This section couldn't be loaded."}
            description={this.props.showDetail ? String(this.state.error?.message || this.state.error) : undefined}
          />
        )
      );
    }
    return this.props.children;
  }
}
